import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right",
  "use": "icon-icon_right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_right\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"#2E5BFD\" fill-rule=\"nonzero\" d=\"m8.781 8-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol